module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60fd617f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/totalpages.vue
// module id = 1059
// module chunks = 0